// Phase 8 — Barcode list screen, migrated to shadcn/Tailwind.
//
// UI only: antd Button/Row/Col → shadcn Button + a Tailwind grid. The JSZip export
// and the BarCodeMultipleDownload (jsbarcode) rendering are unchanged.
import BarCodeMultipleDownload from "./SubComponents/barcodeMultipleDownload";
import JSZip from 'jszip';
import { saveAs } from "file-saver";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "ui/button";

const BarcodeListScreen = () => {

    const apparelReducerState: any = useSelector((state: any) => state.ApparelReducerState);
    const { barcodeList } = apparelReducerState;
    const navigate = useNavigate();

    const downloadZip = () => {
        var zip = new JSZip();
        for (let item of barcodeList) {
            let canvas: any = document.getElementById("barcode" + item.productId);
            let dataURL = canvas.toDataURL("Canvas");
            canvas = null;
            var base64String = dataURL.replace("data:image/png;base64,", "");
            zip.file(`${item.productId}.png`, base64String, { base64: true });
        }
        zip.generateAsync({ type: "blob" }).then(function (content) {
            saveAs(content, "bardcodes.zip");
        });
    }

    return (
        <div className="mz h-full overflow-y-auto p-5">
            <div className="flex items-center justify-between">
                <Button variant="outline" onClick={() => navigate(-1)}>
                    <ArrowLeft className="mr-1 h-4 w-4" /> Go Back
                </Button>
                <Button onClick={downloadZip}>Download zip</Button>
            </div>
            <div className="mt-6 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
                {(barcodeList || []).map((product: any, index: any) => (
                    <div key={index} className="flex items-center justify-center">
                        <BarCodeMultipleDownload product={product} />
                    </div>
                ))}
            </div>
        </div>
    )
}

export default BarcodeListScreen;
